<template>
  <section>
    <input v-for="el in options" :key="el.id" type="radio" v-model="type" :id="el.id" :value="el.value" />

    <div class="selector">
      <label
        v-for="el in options"
        :key="el.id"
        :for="el.id"
        :class="{
          is_selected: type === el.value,
        }"
      >
        {{ $t(el.label) }}
      </label>
    </div>
  </section>
</template>

<script>
import i18n from '../../lang'

export default {
  name: 'DeliveryType',
  metaInfo: {
    title: i18n.t('Delivery details'),
  },
  data() {
    return {
      defaultDelivery: 'delivery',
      options: [
        {
          id: 'delivery',
          value: 'delivery',
          label: 'deliverBoxToHome',
        },
        {
          id: 'pickup',
          value: 'pickup',
          label: 'pickUpBoxesYourself',
        },
      ],
    }
  },
  created() {
    if (this.defaultDelivery && this.type === null) {
      this.$store.dispatch('cart/changeDeliveryType', this.defaultDelivery)
    }
  },
  computed: {
    type: {
      set(value) {
        this.$store.dispatch('cart/changeDeliveryType', value)
      },
      get() {
        return this.$store.state.cart.deliveryType
      },
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  @include container();
  margin-top: 5px;
  position: relative;
  z-index: 4;
}

input[type='radio'] {
  display: none;
  visibility: hidden;
}
.selector {
  @include fontStyleNavi();
  display: flex;
  max-width: 390px;
  border: 1px solid $colorBlack;
  border-radius: 38px;
  padding: 10px;

  @include mq($from: mobile) {
    display: inline-block;
    max-width: none;
  }

  label {
    padding: 9px 15px;
    color: $colorBlack;
    text-align: center;
    border-radius: 25px;
    transition: background-color 0.2s, color 0.2s;
    cursor: pointer;
    display: inline-block;
    line-height: 1;
    flex: 1 1 auto;
    text-align: left;

    @include mq($from: mobile) {
      line-height: calc(20 / 16);
      flex: auto;
    }

    &.is_selected {
      background: $colorBlack;
      color: $colorWhite;
    }

    &.is_disabled {
      opacity: 0.5;
    }
  }
}
</style>
